import { Pipe, PipeTransform } from '@angular/core';

const REGISTERED_MARK_REGEX = /®/g;
const REGISTERED_MARK_SUPERSCRIPT_REGEX = /<sup(?:\s[^>]*)?>\s*®\s*<\/sup>/gi;
const SLIICER_REGISTERED_MARK_REGEX = /\bsliicer\b(\s*®)?/gi;
const TRADEMARK_MARK_REGEX = /™/g;
const TRADEMARK_MARK_SUPERSCRIPT_REGEX = /<sup(?:\s[^>]*)?>\s*™\s*<\/sup>/gi;

@Pipe({ name: 'superscriptMarks' })
export class SuperscriptMarksPipe implements PipeTransform {
    public transform(value: string | null | undefined): string | null | undefined {
        if (!value) return value;

        return value
            .replace(REGISTERED_MARK_SUPERSCRIPT_REGEX, '®')
            .replace(TRADEMARK_MARK_SUPERSCRIPT_REGEX, '™')
            .replace(SLIICER_REGISTERED_MARK_REGEX, 'SLiiCER®')
            .replace(REGISTERED_MARK_REGEX, '<sup>®</sup>')
            .replace(TRADEMARK_MARK_REGEX, '<sup>™</sup>');
    }
}
